<template>
  <div class="home">
    <header class="header">
      <!-- logo -->
      <div class="logo">
        <img src="../assets/images/index/logo@2x.png" alt />
      </div>
      <!-- 搜索框 -->
      <div class="search-wrap" @click="$router.push('/search')">
        <div class="icon">
          <img src="../assets/images/index/dbsousuo@2x.png" alt />
        </div>
        <span>请输入型号或相关信息</span>
      </div>
      <!-- 个人中心 -->
      <div class="mine" @click="$router.push('/main')">
        <div class="icon">
          <img src="../assets/images/tabbar/wodehei@2x.png" alt />
        </div>
        <p>会员</p>
      </div>
    </header>
    <!-- banner -->
    <div class="swiper">
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item,index) in swiperList" :key="index">
          <img :src="item.imgAddress" alt />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 分类 -->
    <div class="category-wrap">
      <ul>
        <li v-for="(item,index) in cateList" :key="index" @click="$router.push('/category')">
          <div class="category-img">
            <img :src="item.img" alt />
          </div>
          <p>{{item.text}}</p>
        </li>
      </ul>
    </div>
    <!-- 合作品牌 -->
    <div class="brand_wrap">
      <h4>合作品牌</h4>
      <ul>
        <li v-for="(item,index) in CooperationBrand" :key="index">
          <img :src="item.imgAddress" alt />
        </li>
      </ul>
    </div>
    <!-- 商品分类 -->
    <div class="product_wrap">
      <Product :productList="productListOne" title="TI(德州仪器)" />
      <Product :productList="productListTwo" title="ST(意法半导体)" />
      <Product :productList="productListThree" title="ON(安森美)" />
    </div>
  </div>
</template>

<script>
import Product from "../components/Product";
import { homeProduct, homeAd } from "../request/api";
export default {
  name: "home",
  data() {
    return {
      productListOne: [],
      productListTwo: [],
      swiperList: [],
      CooperationBrand: [],
      productListThree: [],
      cateList: [
        {
          img: require("../assets/images/index/dianyuanxinpian@2x.png"),
          text: "电源芯片"
        },
        {
          img: require("../assets/images/index/luojixinpian@2x.png"),
          text: "逻辑芯片"
        },
        {
          img: require("../assets/images/index/jingguanti@2x.png"),
          text: "晶体管"
        },
        {
          img: require("../assets/images/index/xinpianchuliqi@2x.png"),
          text: "微控制器"
        },
        {
          img: require("../assets/images/index/qudongqi@2x.png"),
          text: "驱动器"
        },
        {
          img: require("../assets/images/index/spjt@2x.png"),
          text: "射频晶体"
        },
        {
          img: require("../assets/images/index/qianrushi@2x.png"),
          text: "嵌入式芯片"
        },
        {
          img: require("../assets/images/index/chuanganqi@2x.png"),
          text: "传感器"
        },
        {
          img: require("../assets/images/index/faguangguan@2x.png"),
          text: "发光管"
        },
        {
          img: require("../assets/images/index/gnmk@2x.png"),
          text: "功能模块"
        }
      ]
    };
  },
  components: {
    Product
  },
  created() {
    this.getHomeProduct();
    this.getHomeAd();
  },
  methods: {
    //首页楼层数据
    getHomeProduct() {
      homeProduct({}).then(res => {
        this.productListOne = res.data.F1;
        this.productListTwo = res.data.F2;
        this.productListThree = res.data.F3;
        let token = localStorage.getItem("token");
        if (token) {
          this.$store.dispatch("getCartList");
        }
      });
    },
    //首页广告图片
    getHomeAd() {
      homeAd({}).then(res => {
        //轮播图
        this.swiperList = res.data.HomeCarousel;
        //合作品牌
        this.CooperationBrand = res.data.CooperationBrand;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.home {
  background: #f2f2f2;
}
.header {
  width: 100%;
  height: 90px;
  padding: 0 30px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  background: #fff;
  position: sticky;
  z-index: 99;
  top: 0;
  .logo {
    width: 140px;
    height: 62px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .search-wrap {
    width: 450px;
    height: 72px;
    line-height: 72px;
    background: #f5f5f5;
    border-radius: 10px;
    margin: 0 26px 0 30px;
    color: #a8a8a8;
    font-size: 30px;
    display: flex;
    align-items: center;
    .icon {
      width: 36px;
      height: 36px;
      margin: -20px 18px 0 18px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .mine {
    font-size: 18px;
    color: #999;
    width: 50px;
    text-align: center;
    .icon {
      width: 44px;
      height: 44px;
      margin-bottom: 5px;
      img {
        width: 100%;
        height:100%;
      }
    }
  }
}
// 轮播
.swiper {
  width: 100%;
  height: 320px;
  // margin-top: 120px;
  img {
    width: 100%;
    height: 100%;
  }
}
// 分类
.category-wrap {
  width: 100%;
  background: #fff;
  padding: 0px 50px 30px 50px;
  box-sizing: border-box;
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      color: #333;
      font-size: 24px;
      margin-right: 40px;
      text-align: center;
      margin-top: 30px;
      .category-img {
        width: 90px;
        height: 90px;
        margin-bottom: 20px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    li:nth-child(5n) {
      margin-right: 0px;
    }
    li:nth-child(7) {
      margin-left: -12px;
    }
    li:nth-child(8) {
      margin-left: -11px;
    }
  }
}
// 品牌合作
.brand_wrap {
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  background: #fff;
  margin-top: 20px;
  h4 {
    font-size: 32px;
    color: #2e2e2e;
    font-weight: bold;
    margin-bottom: 5px;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 217px;
      height: 95px;
      overflow: hidden;
      margin: 20px 13px 0 0;
      box-shadow: 0px 6px 14px 4px rgba(132, 132, 132, 0.15);
      border-radius: 5px;
      border: solid 1px #f5f5f5;
      position: relative;
      img {
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
      }
    }
    li:nth-child(3n) {
      margin-right: 0;
    }
  }
}
.product_wrap {
  padding-bottom: 100px;
}
</style>